//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
import "../no/PartFamilyMemberValues.js";
let d=[[],[[[],"Dispose",{},0,1],[[],"GetMemberCount",{R_:{member_count:''}},0,1],[["member_index"],"CreateMember",{R_:{member_part:"Part"}},1,1],[["member_data"],"AddMember",{R_:{member_index:''}},1,1],[["member_index","new_member_data"],"EditMember",{},2,1],[["member_index"],"DeleteMember",{},1,1],[["member_name"],"AskIndexOfMemberName",{R_:{member_index:''}},1,1],[[],"PrintFamilyTable",{},0,1],[["member_index"],"EstablishMember",{R_:{member_name:''}},1,1]],[]];
SPLM.PartFamilyManager = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PartFamilyManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;